module.exports = __webpack_public_path__ + "images/emoji/clock11.a3a8dc02858a80d8a267.png";